import {
  UPDATE_DATA,
  UPDATE_EXTRA_DATA_FIELD,
  DELETE_EXTRA_DATA_FIELD,
  ADD_EXTRA_DATA,
  RESET_STATE,
} from './constants'


export const updateData = (name, value) => {
  return {
    type: UPDATE_DATA,
    name, value
  }
}

export const addExtraData = (key, value) => {
  return {
    type: ADD_EXTRA_DATA,
    key, value
  }
}

export const resetState = () => {
  return {
    type: RESET_STATE
  }
}

/*
* isKey => indicates whether we are editting key-name or value-name
*/
export const updateExtraData = (id, inputValue, isKey) => {
  return {
    type: UPDATE_EXTRA_DATA_FIELD,
    id, inputValue, isKey
  }
}

export const deleteExtraData = (id) => {
  return {
    type: DELETE_EXTRA_DATA_FIELD,
    id
  }
}



// WEBPACK FOOTER //
// ./src/components/PolicyForm/actions.js